/**
 * the stringToInteger will take a string and only return the integers contained within it.
 **/
export default function stringToInteger(str) {
  const newNum = str.replace(/\D+/g, '');
  return parseInt(newNum, 10);
}